import { useEffect } from "react";

export function useGlobalKey(key: string, handler: (e: KeyboardEvent) => void) {
    useEffect(() => {
        const listener = (e: KeyboardEvent) => {
            if (e.key.toLowerCase() === key.toLowerCase()) {
                handler(e);
            }
        };

        window.addEventListener('keydown', listener);
        return () => window.removeEventListener('keydown', listener);
    }, [key, handler]);
}